import React, { ChangeEventHandler, FC, useCallback, useRef, useState } from 'react';

interface IProps {
    length: number;
    bigWords?: boolean;
}


const showLength = false;
const RedactedWord: FC<IProps> = (props) => {
    const { length, bigWords } = props

    const [currentText, setCurrentText] = useState<string>("")
    const textRef = useRef("")

    const onFull = useCallback((text: string) => {
        if (textRef.current === text) {
            const current = spanRef.current;
            if (current === null) {
                return;
            }
            const redactedIter = document.getElementsByClassName("redacted");
            const redacteds = [];
            for (var element of redactedIter) {
                redacteds.push(element)
            }
            const idx = 1 + redacteds.indexOf(current);
            if (idx > 0 && idx < redacteds.length) {
                const next = (redacteds[idx].children[0]) as HTMLInputElement;
                next.select();
            }

        }
    }, [])

    const onChange: ChangeEventHandler<HTMLInputElement> = useCallback((event) => {

        let newValue = event.target.value;
        if (newValue.length > length) {
            newValue = newValue.substring(0, length);
            if (textRef.current === newValue) {
                return;
            }
        }

        setCurrentText(newValue)
        textRef.current = newValue;
        if (newValue.length === length) {

            const handle = window.setTimeout(onFull, 500, newValue);
            return () => {
                window.clearTimeout(handle);
            }
        }
    }, [onFull, length])

    const spanRef = useRef<HTMLSpanElement>(null)

    const full = currentText.length === length;

    let width = 9 + (7 * length);
    if (bigWords) {
        width = 12 + (15 * length)
    }
    return <span ref={spanRef} className={`redacted mono ${full ? "full" : ""}`}>
        <input onChange={onChange} type="text" maxLength={length}
            style={{ width: `${width}px` }} />
        {showLength && (<sup>{`(${length}) `}</sup>)}
    </span>
}

export default RedactedWord;